import StyledLink from '../StyledLink'
import {
  EDIT,
  SYSTEM,
  TEST_MANAGEMENT_TOOLS
} from '../routes'
import type { Props } from '../types'

interface Params {
  id: string
}

const LinkToEditTestManagementTool = ({
  children,
  id,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${SYSTEM}/${TEST_MANAGEMENT_TOOLS}/${id}/${EDIT}`}
  >
    {children}
  </StyledLink>

export default LinkToEditTestManagementTool
